require("./sitio");

// slide
import Splide from "@splidejs/splide";

let slide_caracteristicas = new Splide("#slide-caracteristicas", {
    // type: "loop",
    perPage: 3,
    autoplay: false,
    arrows: true,
    perMove: 1,
    pagination: false,
    breakpoints: {
        991: {
            perPage: 2,
        },
        575: {
            perPage: 1,
        },
    },
}).mount();

let slide_proceso = new Splide("#slide-proceso", {
    type: "fade",
    perPage: 1,
    autoplay: false,
    arrows: true,
    perMove: 1,
    pagination: false,
}).mount();

require("./components/FormularioInversionistas");

function ajustaFlechas() {
    const $imagen = $("#slide-proceso").find(".is-active").find(".imagen");
    const flechas = $("#slide-proceso");
    const offset = $imagen.offset();
    const height = $imagen.height();
    const width = $imagen.width();
    const $prev_arrow = $("#slide-proceso").find(".splide__arrow--prev");
    const $next_arrow = $("#slide-proceso").find(".splide__arrow--next");
    $prev_arrow.css("left", `${offset.left}px`);
    $next_arrow.css("left", `${offset.left + width - 29}px`);
    let top = height / 2;
    console.log(top);
    if ($(window).width() <= 991) {
        top =
            ($("#slide-proceso").find(".is-active").find(".etapa").height() +
                200 +
                height) /
            2;
    }

    $prev_arrow.css("top", `${top}px`);
    $next_arrow.css("top", `${top}px`);
}

$(document).ready(function () {
    ajustaFlechas();
    $(window)
        .on("resize", function () {
            ajustaFlechas();
        })
        .on("scroll", function () {
            ajustaFlechas();
        });
});
